<template>
  <div class="account-card-wrapper" :class="{'connected': $props.connected}">
    <transition name="fade" mode="out-in">
      <div class="header" v-if="!$props.validationMode">
        <div class="data-wrapper">
          <i v-if="$props.type === 'BOX'" class="icon-sc-box"></i>
          <i v-else-if="$props.type === 'MOBILE_POSTPAID' || $props.type === 'MOBILE_PREPAID'" class="icon-sc-mobile"></i>
          <i v-else-if="$props.type === 'FIXED_TELEPHONY'" class="icon-sc-landline"></i>
          <i v-else-if="$props.type === 'TELEVISION'" class="icon-sc-tv"></i>
          <i v-else-if="$props.type === 'INTERNET'" class="icon-sc-internet"></i>
          <div>
            <h4 class="title">
              {{ $props.title }}
            </h4>
            <p class="label">
              <slot name="label">{{ $props.label }}</slot>
            </p>
          </div>
        </div>
        <div class="name">
          <slot name="name">{{ $props.name }}</slot>
        </div>
      </div>
    </transition>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'account-card',
  props: {
    type: {
      type: String,
      default: ''
    },
    connected: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    button: {
      type: Boolean,
      default: false
    },
    delete: {
      type: Boolean,
      default: false
    },
    validationMode: Boolean
  },
  computed: {
    iconClasses () {
      return [`icon-sc-${this.$props.icon}`]
    }
  }
}
</script>

<style scoped lang="scss">
.account-card-wrapper {
  width: 100%;
  min-height: 13rem;
  background: $white;
  border-radius: 5px;
  padding: 1.6rem;
  margin: .4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (map_get($breakpoints, sm)) {
    min-height: 15.4rem;
  }

  &.connected {
    min-height: 7.5rem;

    .name {
      border-left: 1px solid $tab-border-color;
      padding-left: 1.8rem;
      //word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      // truncates text if there's more than 2 lines
      // works in Chrome, FF
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;

      @media (map_get($breakpoints, md)) {
        padding-left: 3.3rem;
      }
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
  }

  .data-wrapper {
    display: inline-flex;
    align-items: center;
    margin-right: .5rem;

    .title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 0;
      white-space: nowrap;
    }

    .label {
      color: $dark-grey;
      font-size: 1.2rem;
      margin-bottom: 0;
    }

    i {
      font-size: 3.2rem;
      color: $primary;
      margin-right: 1.6rem;
      display: none;

      @media (map_get($breakpoints, sm)) {
        display: inline-block;
      }
    }
  }

  .name {
    color: $light-black;
    font-size: 16px;
    font-weight: 600;
  }

  .transparent {
    background: transparent;
    color: $primary;
    border: 1px solid $primary;
    width: 100%;
    font-weight: bold;
  }

  .red-btn {
    background: $primary;

    &:hover {
      background: #DE1333;
    }
  }
}

</style>
